var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C5.134 17 2 13.866 2 10C2 6.134 5.134 3 9 3C12.866 3 16 6.134 16 10C16 13.866 12.866 17 9 17ZM9 15.6C12.0928 15.6 14.6 13.0928 14.6 10C14.6 6.9072 12.0928 4.4 9 4.4C5.9072 4.4 3.4 6.9072 3.4 10C3.4 13.0928 5.9072 15.6 9 15.6ZM8.30182 12.8L5.33199 9.83018L6.32195 8.84017L8.30182 10.8201L12.2617 6.8603L13.2516 7.85025L8.30182 12.8Z",
    fill: "#25926A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedIcon);
export default __webpack_public_path__ + "static/media/completedIcon.6a37256428c4cc73c4b9bdd410748158.svg";
export { ForwardRef as ReactComponent };